module.exports = __webpack_public_path__ + "static/media/mdi_comment-alert.2dec5519.svg";